<div class="page-container">
  <div class="header">
    <div class="row">
      <div>{{learnset?.name}}</div>
      <div class="score">{{cumulativeScore}} XP</div>
    </div>
    <div class="progress-bar">
      <div [style.width]="cardsProgress + '%'" class="progress-fill"></div>
    </div>
  </div>

  <app-message *ngFor="let message of messages" [message]="message"></app-message>
  <app-loader *ngIf="generatingSessions" [text]="'Lerneinheiten werden zusammengestellt'"></app-loader>

  <div class="footer">
    <div class="input-wrapper">
      <textarea [(ngModel)]="text" [placeholder]="'Nachricht eingeben'" (keydown.enter)="handleSend(); $event.preventDefault()"></textarea>
      <button type="submit" (click)="handleSend()" [disabled]="text.length === 0"><i class="fas fa-circle-up" [class.primary-color]="text.length > 0"></i></button>
    </div>
  </div>
</div>